<template>
  <div class="section-box">
    <div class="customer-list">
      <el-row class="customer-row-bg">
        <el-col
          :span="20"
          style="text-align: left; display: flex; align-items: center"
        >
          <el-form :inline="true" label-width="90px" label-position="left">
            <el-form-item label="企业名称">
              <el-input v-model="form.CompanyName"></el-input>
            </el-form-item>
            <el-form-item label="负责人" v-if="isShowAdminUserSelect">
              <el-select v-model="form.AdminUserId" placeholder="请选择负责人">
                <el-option label="请选择负责人" :value="0"></el-option>
                <el-option
                  v-for="(item, index) in adminUserData"
                  :label="item.RealName"
                  :value="item.AdminUserId"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="4">
          <el-form
            inline
            label-width="90px"
            label-position="left"
            style="text-align: right"
          >
            <el-form-item>
              <el-button size="medium" type="primary" @click="handleSearch"
                >查询</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button size="medium" type="success" @click="handleReset"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

    <!-- 列表 -->
    <el-table
      :stripe="true"
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F5F7FA' }"
      @sort-change="sortChange"
    >
      <!-- eslint-disable  -->
      <el-table-column
        label="企业ID"
        prop="0"
        show-overflow-tooltip
        width="100"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.CompanyId || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="企业名称" show-overflow-tooltip width="250">
        <template slot-scope="scope">
          <span>{{ scope.row.CompanyName || "--" }}</span>
        </template>
      </el-table-column>


      <el-table-column
        label="今年发单数"
        show-overflow-tooltip
        width="120"
        prop="8"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.ThisYearJobCount  }}单</span>
        </template>
      </el-table-column>

      <el-table-column
        label="今年成单金额"
        show-overflow-tooltip
        width="150"
        prop="9"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.ThisYearSendJobAmount  }}元</span>
        </template>
      </el-table-column>

      <el-table-column
        label="发单增长率"
        show-overflow-tooltip
        width="120"
        prop="1"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span :title="'(今年发单数-去年同期发单数)/去年同期发单数 = ('+scope.row.ThisYearJobCount.toFixed(0)+'-'+scope.row.PastYearJobCount.toFixed(0)+')/'+scope.row.PastYearJobCount.toFixed(0)">{{ scope.row.SendJobCountGrowthRate || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="成单金额增长率"
        show-overflow-tooltip
        width="150"
        sortable="custom"
        prop="2"
      >
        <template slot-scope="scope">
          <span :title="'(今年成单金额-去年同期成单金额)/去年同期成单金额 = ('+scope.row.ThisYearSendJobAmount.toFixed(2)+'-'+scope.row.PastYearSendJobAmount.toFixed(2)+')/'+scope.row.PastYearSendJobAmount.toFixed(2)"> {{ scope.row.CompleteJobAmountGrowthRate || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="发单量达成率"
        show-overflow-tooltip
        width="130"
        sortable="custom"
        prop="3"
      >
        <template slot-scope="scope">
          <span :title="'今年发单数/目标发单数 = '+scope.row.ThisYearJobCount.toFixed(0)+'/'+scope.row.TargetJobCount.toFixed(0)"> {{ scope.row.SendJobCountAchievingRate || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="成单金额达成率"
        show-overflow-tooltip
        width="150"
        sortable="custom"
        prop="4"
      >
        <template slot-scope="scope">
          <span :title="'今年成单金额//目标成单金额 = '+scope.row.ThisYearSendJobAmount.toFixed(2)+'/'+scope.row.TargetJobAmount.toFixed(2)"> {{ scope.row.CompleteJobAmountAchievingRate || "--" }}</span>
        </template>
      </el-table-column>

      <!-- <el-table-column
        label="平均利润"
        show-overflow-tooltip
        width="120"
        sortable="custom"
        prop="5"
      >
        <template slot-scope="scope">
          <span> {{ "￥" + scope.row.AggregateProfit }}</span>
        </template>
      </el-table-column> -->

      <el-table-column
        label="综合利润率"
        show-overflow-tooltip
        width="120"
        sortable="custom"
        prop="7"
      >
        <template slot-scope="scope">
          <span :title="'(今年单子上游金额-今年单子下游金额)/今年单子上游金额 = ('+scope.row.ThisYearSendJobAmount.toFixed(2)+'-'+scope.row.ThisYearReceiverJobAmount.toFixed(2)+')/'+scope.row.ThisYearSendJobAmount.toFixed(2)"> {{ scope.row.AggregateProfitRete }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="距上一次发单天数"
        show-overflow-tooltip 
        sortable="custom"
        prop="6"
      >
        <template slot-scope="scope">
          <span> {{ scope.row.DayCount==-1?"--":scope.row.DayCount+"天" }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right" v-show="tableData.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.PageNum"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="form.PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getAdminUser, //获取销售列表
  getDynamicWarningData,
} from "@/service/salesStatistics";
import {
  getStorageUserRoleId,
  getStorageAdminUser,
} from "@/utils/store";
export default {
  data() {
    return {
      isShowAdminUserSelect:
        getStorageAdminUser().roleName.indexOf("销售总监") >= 0,
      listLoading: false,
      form: {
        PageNum: 1,
        PageSize: 10,
        OrderType: 0,
        IsDesc: true,
        CompanyName: "", //企业名称
        AdminUserId: 0, //负责人
      },
      adminUserData: [],
      total: 0, //总条数
      tableData: [],
    };
  },
  created() {
    if (this.isShowAdminUserSelect) {
      this.GetAdminUserData();
    }
    this.tableData = [];
    this.handleSearch();
  },
  methods: {
    // 查询
    handleSearch() {
      this.handleCurrentChange(1);
    },
    // 重置
    handleReset() {
      this.form.OrderType = 0;
      this.form.IsDesc = true;
      this.form.CompanyName = "";
      this.form.AdminUserId = 0;
      this.handleSearch();
    },
    handleSizeChange(val) {
      if (this.listLoading) return;
      this.form.PageNum = 1;
      this.form.PageSize = val;
      this.GetDynamicWarningData();
    },
    handleCurrentChange(val) {
      if (this.listLoading) return;
      this.form.PageNum = val;
      this.GetDynamicWarningData();
    },
    //获取我的客户列表
    async GetDynamicWarningData() {
      this.listLoading = true;
      let data = this.form;
      //    !data.CompanyName && delete data.CompanyName
      //    !data.AdminUserId && delete data.AdminUserId
      
      if (!this.isShowAdminUserSelect) {
        data.AdminUserId=getStorageUserRoleId();
       }

      console.log("data");
      console.log(this.form);
      console.log(data);
  
      let res = await getDynamicWarningData(data);
      this.listLoading = false;
      if (res.Result != 1) {
        return this.$message.error("获取失败请联系开发人员");
      }
      this.tableData = res.Data.CompanyList;
      this.total = res.Data.TotalCount;
    },
    //获取负责人
    async GetAdminUserData() {
      var data = { RoleCodeArray: ["XSJL", "XSZG"] };
      let res = await getAdminUser(data);
      if (res.Result != 1) {
        return this.$message.error("获取负责人失败请联系开发人员");
      }
      this.adminUserData = res.Data.UserList;
    },
    sortChange(column) {
      console.log(column); 
      this.form.OrderType = column.prop;
      this.form.IsDesc = true;
      if(column.order)
      {
        this.form.IsDesc =column.order== "descending";
      }
      this.handleCurrentChange(1);
    },
  },
};
</script>
<style lang="scss" scoped>
.customer-list {
  position: relative;
  .next-button {
    position: absolute;
    right: 0;
    top: -56px;
  }
}
.customer-row-bg {
  padding: 20px 14px;
  background-color: #f9fafc;
  display: flex;
  align-items: center;
  .el-form-item {
    margin-bottom: 0 !important;
  }
  .selected {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}
</style>